module.exports = __webpack_public_path__ + "img/Picture11.ba7c3b24.png";